import { render, staticRenderFns } from "./planForm.vue?vue&type=template&id=f2047d30&"
import script from "./planForm.vue?vue&type=script&lang=js&"
export * from "./planForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2047d30')) {
      api.createRecord('f2047d30', component.options)
    } else {
      api.reload('f2047d30', component.options)
    }
    module.hot.accept("./planForm.vue?vue&type=template&id=f2047d30&", function () {
      api.rerender('f2047d30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/policy/entry/planForm.vue"
export default component.exports